import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import CustomQuerySetupApiMetricBuilderExtractionExpressionComponent from 'webapp/components/custom-query/setup/api-metric-builder/extraction-expression';
import CustomQuerySetupApiMetricBuilderRawResponseComponent from 'webapp/components/custom-query/setup/api-metric-builder/raw-response';

import type CustomMetricSetupFormApiMetricBuilder from 'webapp/models-custom/custom-metric-setup-form/api-metric-builder';

interface Args {
	form: CustomMetricSetupFormApiMetricBuilder;
	isDisabled: boolean;
	theme: string;
	onContentChange: () => void;
}

export default class CustomQuerySetupApiMetricBuilderRawResponseAndExpressionComponent extends Component<Args> {
	// this is updated in RawResponse and proxied here to ExtractionExpression
	// used to update height on code editors
	@tracked maxCodeEditorHeight: number | null = null;

	get isDisabled(): boolean {
		return this.args.isDisabled || this.args.form.isPreviewButtonLoading;
	}

	get showResponseAndExpression(): boolean {
		return !!this.args.form.rawData || !!this.args.form.extractionExpression;
	}

	@action
	onMaxCodeEditorHeightChange(maxHeight: number): void {
		this.maxCodeEditorHeight = maxHeight;
	}
	<template>
		{{#if this.showResponseAndExpression}}
			<div class="row row--raw-response-and-expression">

				<CustomQuerySetupApiMetricBuilderRawResponseComponent
					@form={{@form}}
					@isLoading={{@form.isLoadingRawData}}
					@isDisabled={{this.isDisabled}}
					@theme={{@theme}}
					@maxHeightExtraReservedSpace={{80}}
					@onMaxHeightChange={{this.onMaxCodeEditorHeightChange}}
				/>

				<CustomQuerySetupApiMetricBuilderExtractionExpressionComponent
					@form={{@form}}
					@isDisabled={{this.isDisabled}}
					@onContentChange={{@onContentChange}}
					@theme={{@theme}}
					@maxHeight={{this.maxCodeEditorHeight}}
				/>

			</div>
		{{/if}}
	</template>
}
